import React from 'react'
import Lottie from 'react-lottie'

// import json1 from '../srcJson/Map.json'
// import json2 from '../srcJson/Map_effect.json'

import bottle from '../srcJson/Bottle.json'

import './BottleAnimation.module.scss'

class BottleAnimation extends React.Component {
  static defaultProps = {
    height: 161,
    width: 161
  }

  render () {
    const { width, height } = this.props
    const atomEffect = {
      loop: true,
      autoplay: true,
      animationData: bottle,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    }

    return (
      <div className='bottle-animation' style={{ height }}>
        <Lottie
          options={atomEffect}
          height={height}
          width={width}
        />
      </div>
    )
  }
}

export default BottleAnimation
